import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-house-flat-payment-history-page',
  templateUrl: './house-flat-payment-history-page.component.html',
  styleUrl: './house-flat-payment-history-page.component.scss'
})
export class HouseFlatPaymentHistoryPageComponent {

  @Input() payments: any[] = [];
  @Input() loading: boolean = true;

  getMonthName(
    month: number,
    year: number
  ): string {
    const date = new Date(year, month - 1, 1);
    return date.toLocaleString('es-MX', {
      month: 'long',
      year: 'numeric',
    });
  }

}
